export const prefix = 'fr';
export const namespace = 'dsfr';
export const organisation = '@gouvfr';
